module.exports = __webpack_public_path__ + "static/media/Office Cleaning Services.e118a6a4.webp";